// src/pages/Accounts/supplierPaymentSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPayments,
  fetchPaymentCode,
  fetchDueVouchers,
  fetchSupplierBalance,
  savePayment,
  deletePayment,
  fetchAccountBalance,
  fetchCurrentliablityAccounts,
  fetchDirectIncomeAccounts,
  fetchDueCustomerReturns,
} from "./supplierPaymentThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  payments: [],
  paymentCode: "",
  dueVouchers: {},
  balances: {},
  accountBalances: {},
  dueCustomerReturns: {},
  directIncome: null,
  currentLiability: null,
  loading: false,
  error: null,
  selectedPayment: null,
  isEditPayment: false,
  refreshList: false,
};

const supplierPaymentSlice = createSlice({
  name: "supplierPayments",
  initialState,
  reducers: {
    resetPayments: () => initialState,
    setPaymentCode(state, action) {
      state.paymentCode = action.payload;
    },
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setSelectedPayment(state, action) {
      state.selectedPayment = action.payload;
    },
    setIsEditPayment(state, action) {
      state.isEditPayment = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPaymentCode.fulfilled, (state, action) => {
        state.paymentCode = action.payload;
      })
      .addCase(fetchDueVouchers.fulfilled, (state, action) => {
        state.dueVouchers[action.payload.supplierId] = action.payload.vouchers;
      })
      .addCase(fetchSupplierBalance.fulfilled, (state, action) => {
        state.balances[action.payload.supplierId] = action.payload.balance;
      })
      .addCase(fetchAccountBalance.fulfilled, (state, action) => {
        state.accountBalances[action.payload.accId] = action.payload.balance;
      })
      .addCase(savePayment.fulfilled, (state, action) => {
        // For create/update the API returned object may vary. We'll flag refresh for list.
        state.refreshList = true;
      })
      .addCase(deletePayment.fulfilled, (state, action) => {
        state.payments = state.payments.filter(
          (p) => p.pay_id !== action.payload.id
        );
      })
      .addCase(fetchCurrentliablityAccounts.fulfilled, (state, action) => {
        state.currentLiability = action.payload;
      })
      .addCase(fetchDueCustomerReturns.fulfilled, (state, action) => {
  state.dueCustomerReturns[action.payload.customerId] = action.payload.returns;
})
      .addCase(fetchDirectIncomeAccounts.fulfilled, (state, action) => {
        state.directIncome = action.payload;
      });

  },
});

export const {
  resetPayments,
  setEntryDate,
  setSelectedPayment,
  setIsEditPayment,
  setRefreshList,
  setPaymentCode
} = supplierPaymentSlice.actions;

export default supplierPaymentSlice.reducer;
